/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
query CustomerReadQuery($customerId: ID!) {
  CustomerRead(customerId: $customerId, returnDeliveriesOfTrunk: false) {
    id,
    updatedAt,
    type,
    country,
    entityToBill,
    supportEmail,
    overDraftLimit,
    rateEmail,
    invoiceName
    phone,
    message,
    status
    Company {
      displayName,
      referenceNumber,
      email,
    }
    Billing {
      email,
      smsType,
      alertAmount,
      enableAutoInvoicing,
      period,
      currency,
      address
    }
    Credit {
      limit,
      balance,
      alertAmount
    }
  }
}
`
